import { useCallback, useEffect } from 'react';
import useEventListener from '../use-event-listener/use-event-listener.hook';

// #region Constants
export enum ScreenSizeOption {
  SM = 640,
  MD = 768,
  LG = 1024,
  XL = 1280,
  TwoXL = 1536,
}
// #endregion

// #region Types
export type UseScreenResizeListenerProps = {
  listener: (width: number) => void;
  max?: ScreenSizeOption;
  min?: ScreenSizeOption;
};
// #endregion

/**
 * The listen-based version of useScreenResize hook
 *
 * @params param
 */
export default function useScreenResizeListener({
  listener: passedListener,
  max,
  min,
}: UseScreenResizeListenerProps) {
  // #region Handlers
  const listener = useCallback(() => {
    const size = window.innerWidth;

    if (!!min && !!max) {
      if (size >= min && size < max) passedListener?.(size);
    } else if (min && size >= min) passedListener?.(size);
    else if (max && size < max) passedListener?.(size);
    else if (!min && !max) passedListener?.(size);
  }, [max, min, passedListener]);
  // #endregion

  // #region Effects
  useEffect(() => listener(), [listener]);

  useEventListener({ eventType: 'resize', listener });
  useEventListener({ eventType: 'change', listener, listenTo: 'orientation' });
  // #endregion
}
